module.exports = __webpack_public_path__ + "assets/img/logo.51c23963.png";